<template>
  <div class="date-range-box">
    <v-menu
      v-model="fromDateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="292px"
      min-width="292px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-if="!isRouteChanged"
          dense
          label="จากวันที่เอกสาร"
          append-icon="mdi-calendar-month-outline"
          readonly
          :value="fromDateDisp"
          v-on="on"
          :outlined="outline"
        ></v-text-field>
        <v-text-field
          v-else
          dense
          label="จากวันที่เอกสาร"
          append-icon="mdi-calendar-month-outline"
          readonly
          value=""
          v-on="on"
          :outlined="outline"
        ></v-text-field>
      </template>
      <v-date-picker
        dense
        color="primary"
        locale="en-in"
        v-model="fromDateVal"
        no-title
        @input="fromDateMenu = false"
        :min="minDate"
      ></v-date-picker>
    </v-menu>
    <v-menu
      v-model="toDateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="292px"
      min-width="292px"
      :disabled="fromDateVal == null"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-if="!isRouteChanged"
          dense
          label="ถึงวันที่"
          append-icon="mdi-calendar-month-outline"
          readonly
          :value="toDateDisp"
          v-on="on"
          :disabled="fromDateVal == null"
          :outlined="outline"
        ></v-text-field>
        <v-text-field
          v-else
          dense
          label="ถึงวันที่"
          append-icon="mdi-calendar-month-outline"
          readonly
          value=""
          v-on="on"
          :disabled="fromDateVal == null"
          :outlined="outline"
        ></v-text-field>
      </template>
      <v-date-picker
        color="primary"
        locale="en-in"
        v-model="toDateVal"
        dense
        no-title
        @input="toDateMenu = false"
        :min="minToDate"
      ></v-date-picker>
    </v-menu>
    <div class="!tw-h-full">
      <v-btn
        text
        color="#f05d5d"
        type="button"
        plain
        @click="resetDate"
        class="tw-px-1 tw-flex tw-justify-centertw-items-center"
      >
        <v-icon class="mr-1">mdi-restart</v-icon>
        <b>รีเซ็ตค่า</b>
      </v-btn>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";

export default {
  name: "date-range-search",
  props: {
    onSearch: {
      type: Function,
      required: true,
    },
    onReset: {
      type: Function,
      required: true,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    initialFromDate: {
      type: [String, Date], // Expecting date in "YYYY-MM-DD" format
      default: null,
    },
    initialToDate: {
      type: [String, Date],// Optional, can be null
      default: null,
    },
  },
  data() {
    return {
      fromDateMenu: false,
      fromDateVal: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      isRouteChanged: false
    };
  },
  computed: {
    fromDateDisp() {
      return this.fromDateVal;
    },
    toDateDisp() {
      return this.toDateVal;
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
    
  },
  mounted() {
    if (this.initialFromDate) {
      this.fromDateVal = moment.tz(this.initialFromDate, 'Asia/Bangkok').format('YYYY-MM-DD');
    }
    if (this.initialToDate) {
      this.toDateVal =  moment.tz(this.initialToDate, 'Asia/Bangkok').format('YYYY-MM-DD');
    }
  },
  watch: {
    initialFromDate(val) {
    if (val) {
      this.fromDateVal = moment.tz(val, "Asia/Bangkok").format("YYYY-MM-DD");
    } else {
      this.fromDateVal = null; // Ensure UI is reset
    }
  },
  initialToDate(val) {
    if (val) {
      this.toDateVal = moment.tz(val, "Asia/Bangkok").format("YYYY-MM-DD");
    } else {
      this.toDateVal = null; // Ensure UI is reset
    }
  },
    fromDateVal() {
      if (this.fromDateVal) {
        this.search();
      }
    },
    toDateVal() {
      if (this.fromDateVal && this.toDateVal) {
        this.search();
      }
    },
    $route: {
      handler() {
        this.isRouteChanged = true;
        console.log("Route changed");
        this.resetDatePickers();
      },
      deep: true,
    },
  },
  
  methods: {
    resetDate() {
      this.fromDateVal = null;
      this.toDateVal = null;
      this.onReset();
    },
    search() {
      if (this.fromDateVal && this.toDateVal) {
        const startDate = new Date(this.fromDateVal);
        const endDate = new Date(this.toDateVal);
        this.onSearch(startDate, endDate);
      } else if (this.fromDateVal) {
        const startDate = new Date(this.fromDateVal);
        this.onSearch(startDate, null);
      }
    },
      resetDatePickers() {
          const today = moment().tz("Asia/Bangkok").format("YYYY-MM-DD");
          console.log("fromDateVal", this.fromDateVal);
          this.fromDateVal = today;
          this.toDateVal = today;
          setTimeout(() => {
            this.resetDate();
            this.isRouteChanged = false;
          }, 10)
       
  },
  },
};
</script>
<style scoped lang="scss">
.date-range-box {
  display: flex;
  justify-content: space-between;
  gap: 0.8rem;
}
</style>
